module.exports = __webpack_public_path__ + "img/qingsu-poster-level-4.c2d0e36b.png";